import React, { useCallback, useEffect, useRef } from 'react'
import { CalculatorStep } from '../types/CalculatorStep'
import { Input } from './Input'
import { StepTitle } from './StepTitle'

const Step = ( { step, onChange, onFocus, onBlur, ...props }:Props ) => {

  const formRef = useRef<HTMLFormElement>( null )

  const handleSubmit = useCallback( ( e:React.FormEvent<HTMLFormElement> ) => {
    e.preventDefault()
    e.currentTarget.checkValidity()
    const formData = new FormData( e.currentTarget )
    let data:any = {}
    Array.from( formData.entries( ) ).forEach( ( [ key, val ] ) => {
      data[ key ] = val
    } )

    step && onChange && onChange( data, step )
  }, [ onChange, step ] )

  const handleFocus = useCallback( (  ) => {
    onFocus && onFocus( step )
  }, [ onFocus, step ] )

  const handleBlur = useCallback( ( ) => {
    onBlur && onBlur( step )
  }, [ onBlur, step ] )

  const dispatchFakeChangeEventOnRender = useCallback( () => {
    const evt = new Event( 'submit', { bubbles: true })
    formRef.current && formRef.current.dispatchEvent( evt )
  }, [ formRef ] )

  useEffect( () => {
    //submit once on render to show totals
    dispatchFakeChangeEventOnRender()
  }, [ dispatchFakeChangeEventOnRender ] )

  return ( 
    <form 
      ref={ formRef }
      onBlur={ handleBlur }
      onSubmit={ handleSubmit } 
      onChange={ handleSubmit }
      onFocus={ handleFocus }
      className={`grid gap-2 mb-12 ${props.className ?? '' }` }  
      { ...props } 
    >
      <StepTitle>
        { step?.name } 
      </StepTitle>
      {
        step?.inputs.map( input => (
          <Input key={ input.id } calculatorInput={ input } />
        ))
      }
    </form>
  )
}

interface Props{
  step: CalculatorStep,
  className?: string
  onChange?: ( data:any, step: CalculatorStep ) => any,
  onFocus?: ( step: CalculatorStep ) => void
  onBlur?: ( step: CalculatorStep ) => void
}
export { Step }
